// extracted by mini-css-extract-plugin
module.exports = {"background":"App_background__1bVI8","glass":"App_glass__2zqyg"};